
import { defineComponent } from "vue";
import PianoKeyboard from "./components/PianoKeyboard.vue"; // Update the imported component name

export default defineComponent({
  name: "App",
  components: {
    PianoKeyboard,
  },
});
